//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Video from './Video.vue'

export const SUPPORTED_VIDEO_TYPES = ['video/mp4', 'video/webm', 'video/ogg']

export default {
  name: 'VideoViewer',
  components: {
    Video
  },
  data: function () {
    return {
      showViewer: false,
      id: null,
      fileName: null,
      url: null
    }
  },
  methods: {
    show: function (id, fileName, url) {
      this.showViewer = true
      this.id = id
      this.fileName = fileName
      this.url = url
    },
    hide: function () {
      this.showViewer = false
      this.id = null
      this.fileName = null
      this.url = null
    }
  }
}

